
import React, { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { SimpleRichText } from '@/components/ui/simple-rich-text';

interface SimplifiedRichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SimplifiedRichTextEditor({ 
  value, 
  onChange, 
  placeholder = 'Write something...' 
}: SimplifiedRichTextEditorProps) {
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="border rounded-md">
      <div className="flex items-center justify-between border-b bg-muted/50 p-2 gap-1">
        <div className="text-sm font-medium">
          {isPreviewMode ? 'Preview Mode' : 'Edit Mode'}
        </div>
        <button
          type="button"
          onClick={() => setIsPreviewMode(!isPreviewMode)}
          className="text-xs bg-primary/10 text-primary px-2 py-1 rounded hover:bg-primary/20"
        >
          {isPreviewMode ? 'Edit' : 'Preview'}
        </button>
      </div>

      <div className="p-3 min-h-[150px]">
        {isPreviewMode ? (
          <SimpleRichText content={value} className="prose-sm max-w-none" />
        ) : (
          <Textarea
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            className="w-full min-h-[150px] border-0 focus-visible:ring-0 focus-visible:ring-offset-0"
          />
        )}
      </div>
    </div>
  );
}
